/** Types */
export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const GET_EMPLOYEES_SUCCESS = "GET_EMPLOYEES_SUCCESS";
export const ADD_EMPLOYEES = "ADD_EMPLOYEES";
export const EDIT_EMPLOYEES = "EDIT_EMPLOYEES";
export const DELETE_EMPLOYEES = "DELETE_EMPLOYEES";
export const CHANGE_STATUS_EMPLOYEES = 'CHANGE_STATUS_EMPLOYEES'
